module.exports = __webpack_public_path__ + "img/faceCheckErcode.8ffa64fb.png";